# Used in credit
# Adds a fake spinning loader to the offer calculation

MIN_TIMEOUT = 0.5 * 1000
MAX_TIMEOUT = 1.5 * 1000

getRandomInt = (min, max) ->
  Math.floor(Math.random() * (max - min + 1)) + min

$ ->
  if ($el = $ '[data-behaviour="wait-loader"]').length > 0
    timeout = getRandomInt(MIN_TIMEOUT, MAX_TIMEOUT)
    $el.delay(300).fadeIn().delay(timeout).fadeOut ->
      $($el.data('view')).fadeIn()
